import React from "react"
import { Box, Container, Grid } from "@mui/material"
import Icon from "@mdi/react"
import { mdiMapMarker, mdiPhoneInTalk, mdiEmailOutline } from "@mdi/js"

import ContactForm from "components/Forms/ContactForm"
import { Email, Phone } from "components/i18n/Contact"
import SEO from "@secureo/common/components/SEO"
import BreadCrumbs, { BreadCrumb } from "components/BreadCrumbs"

import { helpCenterAncestorBreadCrumbs } from "./index"

import { CustomAppProps } from "pages/_app"

const ContactPage = ({ asPath, locale, countryCode }: CustomAppProps) => {
	const currentPath: BreadCrumb = {
		href: "/help/contact",
		label: "Kontakt",
	}

	return (
		<>
			<SEO asPath={asPath} appendLocalizedShopNameWithPipe title="Kontakt" />
			<div style={{ position: "relative", overflow: "hidden" }}>
				<img
					alt="grey-circle"
					src="https://res.cloudinary.com/digitalzylinder-shop/image/upload/v1590566180/DigiShop2/Content/Bg-Grey-Circle.png"
					style={{
						position: "absolute",
						right: 0,
						top: 0,
						height: 1100,
						width: 1100,
						objectFit: "cover",
						opacity: 1,
						zIndex: -1,
					}}
				/>
				<BreadCrumbs
					locale={locale}
					currentPath={currentPath}
					ancestors={helpCenterAncestorBreadCrumbs}
				/>
				<Container>
					<Box py={5} style={{ maxWidth: 950, margin: "auto" }}>
						<Grid container spacing={10}>
							<Grid item xs={12} sm={6}>
								<div style={{ maxWidth: 450 }}>
									<div
										style={{
											color: "#4691CE",
											textTransform: "uppercase",
											fontSize: 13,
										}}
									>
										<strong>Wir freuen uns auf Ihre Anfrage!</strong>
									</div>
									<Box mb={2}>
										<h1 style={{ margin: 0 }}>Kontakt</h1>
									</Box>
									<ContactForm />
								</div>
							</Grid>
							<Grid item xs={12} sm={6}>
								<Box
									pt={7}
									pb={5}
									style={{
										background: "#263739",
										color: "white",
										minHeight: 370,
										paddingLeft: "12.5%",
									}}
								>
									<div style={{ display: "flex" }}>
										<div style={{ marginRight: 10 }}>
											<Icon path={mdiMapMarker} size={2} color="white" />
										</div>
										<div>
											<div style={{ fontSize: 22, fontWeight: "bold" }}>
												Anschrift
											</div>
											<div style={{ color: "#F7F9FA" }}>Secureo GmbH</div>
											<div style={{ color: "#F7F9FA" }}>Im Moos 19</div>
											<div style={{ color: "#F7F9FA" }}>6067 Absam</div>
										</div>
									</div>
									<Box mt={3} style={{ display: "flex" }}>
										<div style={{ marginRight: 10 }}>
											<Icon path={mdiPhoneInTalk} size={2} color="white" />
										</div>
										<div>
											<div style={{ fontSize: 22, fontWeight: "bold" }}>
												Telefon
											</div>
											<div style={{ color: "#F7F9FA" }}>
												<Phone countryCode={countryCode} />
											</div>
										</div>
									</Box>
									<Box mt={3} style={{ display: "flex" }}>
										<div style={{ marginRight: 10 }}>
											<Icon path={mdiEmailOutline} size={2} color="white" />
										</div>
										<div>
											<div style={{ fontSize: 22, fontWeight: "bold" }}>
												E-Mail
											</div>
											<div style={{ color: "#F7F9FA" }}>
												<Email />
											</div>
										</div>
									</Box>
								</Box>
							</Grid>
						</Grid>
					</Box>
				</Container>
				<Box className="mapouter" mt={5} mb={-1}>
					<div className="gmap_canvas">
						<iframe
							title="Google Maps Secureo"
							width="100%"
							height="500"
							id="gmap_canvas"
							src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2705.9228109358437!2d11.50565193389063!3d47.29630801252558!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479d6f7c737fbdcd%3A0x1e03ee85b9232ca9!2sIm%20Moos%2019%2C%206067%20Absam!5e0!3m2!1sen!2sat!4v1674488283393!5m2!1sen!2sat"
							frameBorder="0"
							scrolling="yes"
						/>
					</div>
				</Box>
			</div>
		</>
	)
}

export default ContactPage
